
import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Tab } from 'react-bootstrap'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { Link, useLocation } from 'react-router-dom';
import { json } from "stream/consumers";
import clsx from 'clsx';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from "../../../common/Toastr";
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import moment from "moment";
import 'rsuite/dist/rsuite.css';
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import AttachmentModal from "../../attachment/AttachmentModal";
import CanvasLoader from "../../../common/CanvasLoader";
import { formatCurrntDateTime, formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from "../../../common/timeLiveFunction";



const ExpenseSheetPrintForm = (props: any) => {
    const { modelRef } = props;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { MasterData, DetailsData, LogoURL, SheetDetailForCalculation, ReimburseCurrency, ExchangeRate, MasterEmployeeExpenseSheetId, AccountEmployeeId, expensesheetDate, expenseSheetDescription, IsElectronicSignExistInSessionAccount, ImageURL, TotalExpenseAmount, CurrencySymbol } = useAppSelector(state => state.expense);
    const [submittedBy, setSubmittedBy] = useState('');
    const [submittedOn, setsubmittedOn] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [MasterStatus, setMasterStatus] = useState('');
    const [masterReimburse, setMasterReimburse] = useState('');
    ///const [masterReimburse, setMasterReimburse] = useState(0.00);
    const [masterDescription, setDescription] = useState('');
    const [isPrinting, setIsPrinting] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [PreferenceSignatures, SetPreferenceSignatures] = useState('');
    const componentRef = useRef<HTMLDivElement>(null);
    const [isShowElectronicSign, setIsShowElectronicSign] = useState(true);
    const { cultureInfoName, accountPreferenceList, isCompanyOwnLogo, decimalPlaces } = useAppSelector((state) => state.globalState);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [id, setId] = useState(null);
    const attachmentModelRef = useRef<any>(null);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const [summittedBaseTotal, setSubmittedBaseTotal]=useState<number>(0.00);

    useEffect(() => {
        if (accountPreferenceList.length > 0) {
            SetPreferenceSignatures(accountPreferenceList[0].ExpenseSheetPrintFooter)
            setIsShowElectronicSign(accountPreferenceList[0].IsShowElectronicSign);
        }
        if (Object.keys(MasterData).length > 0) {
            const objMasterData: any = MasterData;
            setSelectedEmployee(objMasterData.EmployeeName);
            setSelectedDate(objMasterData.ExpenseSheetDate);
            statusExpenseSheet(objMasterData.Status);

            var TotalReimburseAmount: any = 0.00;
            var TotalAmount: any = 0.00;
            var CurrencyCode: any = "";
            if (Object.keys(SheetDetailForCalculation).length > 0) {
                const ReimburseAmount = SheetDetailForCalculation;
                let totalAmount = 0.00;

                if (Object.keys(ReimburseCurrency).length > 0) {
                    const reimburseArray: any = ReimburseCurrency;
                    CurrencyCode = reimburseArray.CurrencyCode;
                }
                ReimburseAmount.forEach((obj: any) => {
                    if (obj.Reimburse) {
                        // TotalAmount += parseFloat(obj.Amount) * parseFloat(obj.ExchangeRate);
                         TotalAmount += parseFloat(obj.Amount) / parseFloat(obj.ExchangeRate);
                    }
                });
                if (ExchangeRate > 0) {
                    TotalReimburseAmount = parseFloat(TotalAmount) * ExchangeRate;
                } else {
                    TotalReimburseAmount = 1 * parseFloat(TotalAmount);
                }
                //const ReimburseAmountwithCode: any = CurrencyCode + ' ' + TotalReimburseAmount.toFixed(2)
                const ReimburseAmountwithCode: any = CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), TotalReimburseAmount, decimalPlaces)
                console.log(ReimburseAmountwithCode)
                //FormatInvoiceDecimalNumber(cultureInfoName.toString(), ReimburseAmountwithCode, decimalPlaces).
                setMasterReimburse(ReimburseAmountwithCode);
                setDescription(objMasterData.Description);
            };
        };
        setIsCanvasLoader(false);

    }, [MasterData, SheetDetailForCalculation, ReimburseCurrency])

        useEffect(()=>{
            calculateSummittedTotalInBaseCurrency();
        },[ReimburseCurrency])
        const calculateSummittedTotalInBaseCurrency = () => {
             let TotalAmount: any = 0.00;
            if (SheetDetailForCalculation) {
                SheetDetailForCalculation.forEach((obj: any) => {
                    if (obj.Reimburse) {
                        TotalAmount += parseFloat(obj.Amount) / parseFloat(obj.ExchangeRate);
                    }
                    setSubmittedBaseTotal(TotalAmount)
                });
            }
        }

    const statusExpenseSheet = (selectedStatus: any) => {

        let status: any = "";
        if (selectedStatus == "Not Submitted") {
            status = (
                <span className="badge badge-light-warning fs-7">
                    {/* {t('Not Submitted')} */}
                    {getValueFromResource('Not Submitted', dispatch, t)}

                </span>
            )
        } else if (selectedStatus == "Submitted") {
            status = (
                <span className="badge badge-light-primary fs-7">
                    {/* {t('Submitted')} */}
                    {getValueFromResource('Submitted', dispatch, t)}

                </span>
            )
        } else if (selectedStatus == "Approved") {
            status = (
                <span className="badge badge-light-success fs-7">
                    {/* {t('Approved')} */}
                    {getValueFromResource('Approved', dispatch, t)}

                </span>
            )
        } else if (selectedStatus == "Rejected") {
            status = (
                <span className="badge badge-light-danger fs-7">
                    {/* {t('Rejected')} */}
                    {getValueFromResource('Rejected', dispatch, t)}

                </span>
            )
        }
        setMasterStatus(status);
    }

    const RenderEntryStatus = (ExpenseEntryStatus: any) => {
        let Entrystatus: any = "";

        if (ExpenseEntryStatus.ApprovalStatus == "Not Submitted") {
            Entrystatus = (
                <span className="badge badge-light-warning fs-7">
                    {/* {t(' Not Submitted')} */}
                    {getValueFromResource('Not Submitted', dispatch, t)}

                </span>
            )
        } else if (ExpenseEntryStatus.ApprovalStatus == "Pending Approval") {
            Entrystatus = (
                <span className="badge badge-light-primary fs-7">
                    {/* {t('Submitted')} */}
                    {getValueFromResource('Submitted', dispatch, t)}

                </span>
            )
        } else if (ExpenseEntryStatus.ApprovalStatus == "Approved") {
            Entrystatus = (
                <span className="badge badge-light-success fs-7">
                    {getValueFromResource('Approved', dispatch, t)}
                    {/* {t('Approved')} 
                     */}

                </span>
            )
        } else if (ExpenseEntryStatus.ApprovalStatus == "Rejected") {
            Entrystatus = (
                <span className="badge badge-light-danger fs-7">
                    {getValueFromResource('DRejectedlete', dispatch, t)}
                    {/* {t('Rejected')} 
                    */}

                </span>
            )
        }
        return Entrystatus;
    }

    const calculateTotalNetAmount = () => {
        let totalNetAmount = 0;
        DetailsData.forEach((SheetDetails: any) => {
            totalNetAmount += parseFloat(SheetDetails.NetAmount);
        });
        return totalNetAmount.toFixed(2);
    };

    const calculateTotalTaxAmount = () => {
        let taxAmount = 0;
        DetailsData.forEach((SheetDetails: any) => {
            taxAmount += parseFloat(SheetDetails.TaxAmount);
        });
        return taxAmount.toFixed(2);
    };

    const calculateTotalAmount = () => {
        let totalAmount: any = 0.00;
        let FinalAmount: any = 0.00;
        DetailsData.forEach((SheetDetails: any) => {
            totalAmount += parseFloat(SheetDetails.Amount);
        });
        if (Object.keys(MasterData).length > 0) {
            const MasterSheet: any = MasterData;
            FinalAmount = MasterSheet.CurrencyCode + ' ' + totalAmount.toFixed(2)
        }
        return FinalAmount;
    };

    const handlePrintEvent = () => {
        setShowTable(true);
    };
    const handleAttachment = (AccountExpenseEntryId: any) => {
        setId(AccountExpenseEntryId);
        setModalIsOpen(true);
    }


    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    return (

        <>
            <div className="modal drawer-overlay" tabIndex={-1} data-bs-backdrop="false" id="expenseSheetPrintModal" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content rounded'>
                        <div className='modal-header pb-2'>
                            <h6>
                                {/* {t('Expense Entry')} */}
                                {getValueFromResource('Expense Entry', dispatch, t)}

                            </h6>
                            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' >
                                <KTIcon iconName='cross' className='fs-1 svg-icon-1x' />
                            </div>
                        </div>

                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                            {isCanvasLoader ? <CanvasLoader /> : <>
                                <div className='row text-center mb-13' style={{ marginTop: 14 }}>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel' style={{ paddingLeft: 0 }}>
                                            {/* {t('Employee Name')} */}
                                            {getValueFromResource('Employee Name', dispatch, t)}

                                        </span><br />
                                        <span className='tsDetailModalText'>{selectedEmployee}</span>
                                    </div>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel'>
                                            {/* {t('Entry Date')} */}
                                            {getValueFromResource('Entry Date', dispatch, t)}

                                        </span><br />
                                        <span className='tsDetailModalText'>
                                            {/* {moment.parseZone(selectedDate).format('DD MMM yy')} */}
                                            {formatDateWithDateAndMonthName(selectedDate, cultureInfoName.toString())}
                                            </span>
                                        {/* <span className='tsDetailModalText'>{selectedDate}</span> */}
                                    </div>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel'>
                                            {/* {t('Total Reimbursement')} */}
                                            {getValueFromResource('Total Reimbursement', dispatch, t)}

                                        </span><br />
                                        <span className='tsDetailModalText'>{masterReimburse}</span>
                                    </div>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel'>
                                            {/* {t('Status')} */}
                                            {getValueFromResource('Status', dispatch, t)}

                                        </span><br />
                                        <span>{MasterStatus}</span>
                                    </div>
                                </div>
                                <table className='tsReportCommentTable table-bordered'>
                                    <thead>
                                        <tr className='tsReportCommentThead' style={{ textAlign: 'center' }}>
                                            <th>
                                                {/* {t('Date')} */}
                                                {getValueFromResource('Date', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Project Name')}  {t('Expense Name')} */}
                                                {getValueFromResource('Project Name /  Expense Name', dispatch, t)}

                                            </th>
                                             <th>
                                                {/* {t('Payment Method')} */}
                                                {getValueFromResource('Description', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Payment Method')} */}
                                                {getValueFromResource('Payment Method', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Tax Code')} */}
                                                {getValueFromResource('Tax Code', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Billable')} */}
                                                {getValueFromResource('Billable', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Quantity')} */}
                                                {getValueFromResource('Quantity', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Rate')} */}
                                                {getValueFromResource('Rate', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Net')} */}
                                                {getValueFromResource('Net', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Tax')} */}
                                                {getValueFromResource('Tax', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Amount')} */}
                                                {getValueFromResource('Amount', dispatch, t)}

                                            </th>
                                            <th>
                                                {/* {t('Attachment')} */}
                                                {getValueFromResource('Attachment', dispatch, t)}

                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {DetailsData.length > 0 && DetailsData.map((SheetDetails: any, i: any) => (
                                            <tr key={i} className='tsReportCommentTbody' style={{ textAlign: 'center' }}>
                                                <td style={{ paddingLeft: 10 }}>
                                                    {/* {moment.parseZone(SheetDetails.AccountExpenseEntryDate).format('DD MMM yy')} */}
                                                    {formatDateWithDateAndMonthName(SheetDetails.AccountExpenseEntryDate, cultureInfoName.toString())}

                                                </td>
                                                <td >{SheetDetails.ProjectName + " • " + SheetDetails.AccountExpenseName}</td>
                                                <td >{SheetDetails.Description ? SheetDetails.Description : ""}</td>
                                                <td >{SheetDetails.PaymentMethod ? SheetDetails.PaymentMethod : ""}</td>
                                                <td >{SheetDetails.TaxCode ? SheetDetails.TaxCode : ""}</td>
                                                <td >{SheetDetails.IsBillable ? "Yes" : "No"}</td>
                                                <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.Quantity, decimalPlaces)}</td>
                                                <td >{SheetDetails.Rate !== null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.Rate, decimalPlaces) : '0.00'}</td>
                                                {/* <td >{SheetDetails.NetAmount.toFixed(2)}</td> */}
                                                <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.NetAmount, decimalPlaces)}</td>
                                                <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.TaxAmount, decimalPlaces)}</td>
                                                <td >{SheetDetails?.CurrencyCode+" "+ FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.Amount, decimalPlaces)}</td>
                                                <td> <a
                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content=
                                                    // {t("Attachment")}
                                                    {getValueFromResource('Attachment', dispatch, t)}
                                                    data-tooltip-place="bottom"
                                                    onClick={() => handleAttachment(SheetDetails.AccountExpenseEntryId)}
                                                >
                                                    <i className="bi bi-paperclip fs-3 iconColor"></i>
                                                </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        {DetailsData.length > 0 && (
                                            <tr>
                                                <td className='tsReportInfoTbody text-center'> <span className="task projectTaskHeading">
                                                    {/* {'Total'} */}
                                                    {getValueFromResource('Total', dispatch, t)}

                                                </span></td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                {/* <td className='tsReportInfoTbody text-center' > {calculateTotalNetAmount()} </td>
                                                <td className='tsReportInfoTbody text-center'> {calculateTotalTaxAmount()} </td> */}
                                                 <td className='tsReportInfoTbody text-center' ></td>
                                                <td className='tsReportInfoTbody text-center'></td>
                                                {/* <td className='tsReportInfoTbody text-center'>{CurrencySymbol+" "+TotalExpenseAmount?.toFixed(decimalPlaces)}</td> */}
                                                <td className='tsReportInfoTbody text-center'>{CurrencySymbol+" "+FormatInvoiceDecimalNumber(cultureInfoName.toString(), TotalExpenseAmount, decimalPlaces)}</td>
                                                {/* <td className='tsReportInfoTbody text-center'> {calculateTotalAmount()} </td> */}
                                            </tr>
                                        )}
                                    </tfoot>
                                </table>

                                {DetailsData.length === 0 && <div className=''>
                                    <p className='noDataFound'>
                                        {/* {t('No Record Found')} */}
                                        {getValueFromResource('No Record Found', dispatch, t)}
                                    </p>
                                </div>}

                            </>}
                        </div>
                        <div className="modal-footer">
                            <a
                                onClick={() => { handlePrint() }}
                                className={"btn btn-primary btn-sm "}>
                                <i className="bi bi-printer fs-5 me-1"></i>
                                {/* {t('Print Expense Sheet')} */}
                                {getValueFromResource('Print Expense Sheet', dispatch, t)}

                            </a>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'none' }}>
                    <div ref={componentRef} >
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5'>
                            <div className='row text-left mb-13' style={{ marginTop: 25 }}>

                                {isCompanyOwnLogo ?
                                    <img src={LogoURL} className='tsReportIcon' style={{ width: '180px', height: '50px', paddingLeft: 20, marginBottom: 8 }} />
                                    :
                                    <>
                                        <img src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')} className='tsReportLogo' />
                                    </>
                                }
                                <span className='textDarkBlue' style={{ fontWeight: 600, fontSize: 20 }}>
                                    {/* {t('Expense Summary')} */}
                                    {getValueFromResource('Expense Summary', dispatch, t)}
                                </span>
                                 {/* <span className='lightGray' style={{ fontWeight: 500, fontSize: 14, marginLeft: 1 }}>{moment.parseZone(selectedDate).format('DD MMM yy')}</span> */}
                                 <span className='lightGray' style={{ fontWeight: 500, fontSize: 14, marginLeft: 1 }}>
                                    {/* {moment.parseZone(selectedDate).format('DD MMM yy')} */}
                                    {formatDateWithDateAndMonthName(selectedDate, cultureInfoName.toString())}
                                    </span>
                                {/* <span className='lightGray' style={{ fontWeight: 500, fontSize: 14, marginLeft: 1 }}>{selectedDate}</span> */}
                                <div style={{ marginLeft: -5, marginTop: 20 }}>
                                    <span className='reportLabel'>
                                        {/* {t('Total Reimbursement')} */}
                                        {getValueFromResource('Total Reimbursement', dispatch, t)}
                                    </span>
                                    <span className='reportText'>{masterReimburse ? masterReimburse : "0"}</span>
                                    <span className='reportLabel'>
                                        {/* {t('Status')} */}
                                        {getValueFromResource('Status', dispatch, t)}
                                    </span>
                                    <span className='reportText'>{MasterStatus}</span>
                                    <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                        {/* {t('Employee Name')} */}
                                        {getValueFromResource('Employee Name', dispatch, t)}
                                    </span>
                                    <span className='reportText'>{selectedEmployee}</span>
                                </div>
                            </div>
                            <table className='tsReportCommentTable'>
                                <thead>
                                    <tr className='tsReportCommentThead text-center'>
                                        <th>
                                            {/* {t('Date')} */}
                                            {getValueFromResource('Date', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Project Name')} / {t('Expense Name')} */}
                                            {getValueFromResource('Project Name / Expense Name', dispatch, t)}
                                        </th>
                                         <th>
                                            {/* {t('Payment Method')} */}
                                            {getValueFromResource('Description', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Payment Method')} */}
                                            {getValueFromResource('Payment Method', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Tax Code')} */}
                                            {getValueFromResource('Tax Code', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Billable')} */}
                                            {getValueFromResource('Billable', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Quantity')} */}
                                            {getValueFromResource('Quantity', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Rate')} */}
                                            {getValueFromResource('Rate', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Net')} */}
                                            {getValueFromResource('Net', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Tax')} */}
                                            {getValueFromResource('Tax', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Amount')} */}
                                            {getValueFromResource('Amount', dispatch, t)}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {/* {DetailsData.length === 0 && <tr><td> {t('No Record Found.')}</td></tr>} */}
                                    {DetailsData.length === 0 && <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found', dispatch, t)}
                                        </p>
                                    </div>}
                                    {DetailsData.length > 0 && DetailsData.map((SheetDetails: any, i: any) => (
                                        <tr key={i} className='tsReportCommentTbody' style={{ textAlign: 'center' }}>
                                            <td style={{ paddingLeft: 10 }}>{formatDateWithDateAndMonthName(SheetDetails.AccountExpenseEntryDate, cultureInfoName.toString())}</td>
                                            <td >{SheetDetails.ProjectName + " • " + SheetDetails.AccountExpenseName}</td>
                                            <td >{SheetDetails.Description ? SheetDetails.Description : ""}</td>
                                            <td >{SheetDetails.PaymentMethod ? SheetDetails.PaymentMethod : ""}</td>
                                            <td >{SheetDetails.TaxCode ? SheetDetails.TaxCode : ""}</td>
                                            <td >{SheetDetails.IsBillable ? "Yes" : "No"}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.Quantity, decimalPlaces)}</td>
                                            <td >{SheetDetails.Rate !== null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.Rate, decimalPlaces) : '0.00'}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.NetAmount, decimalPlaces)}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.TaxAmount, decimalPlaces)}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), SheetDetails.Amount, decimalPlaces)}</td>

                                        </tr>
                                    ))}




                                </tbody>
                                <tfoot>
                                    {DetailsData.length > 0 && (
                                        <tr>
                                            <td className='tsReportInfoTbody text-center'> <span className="task projectTaskHeading">
                                                {/* {t('Total')} */}
                                                {getValueFromResource('Total', dispatch, t)}
                                            </span></td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody text-center' ></td>
                                            <td className='tsReportInfoTbody text-center'></td>
                                            {/* <td className='tsReportInfoTbody text-center' > {calculateTotalNetAmount()} </td>
                                            <td className='tsReportInfoTbody text-center'> {calculateTotalTaxAmount()} </td> */}
                                            {/* <td className='tsReportInfoTbody text-center'>{CurrencySymbol+" "+TotalExpenseAmount?.toFixed(decimalPlaces)}</td> */}
                                            <td className='tsReportInfoTbody text-center'>{CurrencySymbol+" "+FormatInvoiceDecimalNumber(cultureInfoName.toString(), TotalExpenseAmount, decimalPlaces)}</td>
                                            {/* <td className='tsReportInfoTbody text-center'> {calculateTotalAmount()} </td> */}
                                        </tr>
                                    )}
                                </tfoot>
                            </table>
                            <div className='row' >
                                <textarea defaultValue={PreferenceSignatures} rows={10} style={{ borderRadius: 0, borderStyle: 'none' }}>
                                </textarea>
                            </div>
                            {isShowElectronicSign &&
                                <div id="electronicSignature">
                                    <div className='text-left mb-2'>
                                        <span className='commentHeading'>
                                            {/* {t('Electronic Signature')} */}
                                            {getValueFromResource('Electronic Signature', dispatch, t)}
                                        </span>
                                    </div>
                                    <div className='text-left mb-1'>
                                        <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                            {/* {t('Signed By')} */}
                                            {getValueFromResource('Signed By', dispatch, t)}
                                        </span>
                                        <span className='reportText'>{selectedEmployee}</span>
                                    </div>
                                    {IsElectronicSignExistInSessionAccount &&
                                        <div className='text-left mb-1'>
                                            <span className='reportLabel' style={{ paddingLeft: 6, paddingRight: 6 }}>
                                                {/* {t('Signature')} */}
                                                {getValueFromResource('Signature', dispatch, t)}
                                            </span>
                                            <img id="imgElectronicSignature" alt="" src={ImageURL} style={{ height: '50px' }} />
                                        </div>
                                    }
                                    <div className='text-left mb-1'>
                                        <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                            {/* {t('Timestamp')} */}
                                            {getValueFromResource('Timestamp', dispatch, t)}

                                        </span>
                                        {/* <span className="reportText">{moment.parseZone().format('DD-MM-YYYY HH:mm:ss')}</span> */}
                                        <span className="reportText"> {formatCurrntDateTime(new Date(), cultureInfoName.toString())}</span>
                                        {/* <span className="reportText">{formatDateWithDateAndMonthName(selectedDate, cultureInfoName.toString())}</span> */}
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
            {modalIsOpen && (
                <>
                    <AttachmentModal
                        isOpen={modalIsOpen}
                        closeModal={() => setModalIsOpen(false)}
                        Id={id}
                        IsUploadRequired={false}
                        AccountAttachmentTypeId={1}
                    />
                </>
            )
            }
        </>
    )
}

export default ExpenseSheetPrintForm;